import { useMemo, useCallback } from 'react';
import { usePodcastListStore } from '../../store/usePodcastListStore';
import PodcastCard from '@/pages/podcast/shared/components/podcast-card';
import Button from '@/components/Button';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';

interface LatestPodcastsProps {
  onLoadMore: () => void;
  hasMore: boolean;
  loading: boolean;
}

export const LatestPodcasts = ({ onLoadMore, hasMore, loading }: LatestPodcastsProps) => {
  const page = usePodcastListStore((state) => state.page);
  const podcasts = usePodcastListStore((state) => state.podcasts);

  const title = useMemo(() => page?.latestTitle || 'Latest', [page?.latestTitle]);
  const buttonLabel = useMemo(() => page?.moreButtonTitle || 'View all', [page?.moreButtonTitle]);
  const watchButtonLabel = useMemo(() => page?.card?.watchButtonLabel || null, [page?.card?.watchButtonLabel]);
  const watchAgainButtonLabel = useMemo(
    () => page?.card?.watchAgainButtonLabel || null,
    [page?.card?.watchAgainButtonLabel],
  );

  const handleLoadMore = useCallback(() => {
    if (!loading) {
      onLoadMore();
    }
  }, [onLoadMore, loading]);

  if (!podcasts.length) return null;

  return (
    <AnimatedFadeInComponent>
      <div className="mb-sh-30">
        <h3 className="mb-sh-30 font-haffer text-sh-md font-bold">{title}</h3>
        <div className="grid grid-cols-1 gap-sh-30">
          {podcasts.map((podcast) => (
            <PodcastCard
              key={podcast.documentId}
              podcast={podcast}
              watchButtonLabel={watchButtonLabel}
              watchAgainButtonLabel={watchAgainButtonLabel}
            />
          ))}
        </div>
        {hasMore && (
          <div className="mt-sh-30 flex w-full items-center justify-start">
            <Button theme="solid" onClick={handleLoadMore} disabled={loading}>
              {loading ? 'Loading...' : buttonLabel}
            </Button>
          </div>
        )}
      </div>
    </AnimatedFadeInComponent>
  );
};
